import styled, { css } from 'styled-components';

export const StyledRelativeWrapper = styled.div`
  position: relative;
`;

export const StyledTabsWrapper = styled.div`
  margin: 8px 0;
`;

export const StyledFormWrapper = styled.div`
  margin-top: 15px;
`;

export const StyledFormH4 = styled.h4`
  margin-top: 10px;
`;

export const StyledFlex = styled.div`
  display: flex;
`;

export const StyledSpan = styled.span`
  margin-left: 45px;
`;

export const StyledItem = styled.div`
  padding: 10px;
`;

export const StyledItemList = styled.div`
  padding-top: 5px;
`;

export const StyledBorderTabs = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledFormItems = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledFromTo = styled.span`
  margin: 10px 20px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const ActionHeader = styled.div`
  position: relative;
  border: solid 1px grey;
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;

  ${(props) =>
    props.isExpanded &&
    css`
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    `}
`;

export const ActionHeaderNoExpendable = styled.div`
  position: relative;
  border: solid 1px grey;
  cursor: default;
  padding: 10px;
  border-radius: 10px;
`;

export const ActionContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 0;
  overflow: hidden;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 10px;

  ${(props) =>
    props.isExpanded &&
    css`
      height: ${(p) => (p.height ? p.height : 'auto')};
      overflow: scroll;
      border-right: solid 1px grey;
      border-left: solid 1px grey;
      border-bottom: solid 1px grey;
    `}

  ${(props) =>
    props.shouldTransition &&
    css`
      transition: all 0.4s ease-in-out;
    `}
`;

export const StyledIcons = styled.svg`
  height: 25px;
  position: absolute;
  top: 7px;
  left: 0;
`;

export const StyledTrainsOutbound = styled.svg`
  height: 25px;
  width: 25px;
  position: absolute;
  right: 0;
  top: 4px;
`;

export const StyledTrainsInbound = styled.svg`
  height: 25px;
  width: 25px;
  position: absolute;
  left: 5px;
  top: 4px;
`;

export const StyledChevron = styled.svg`
  height: 25px;
  width: 25px;
  position: absolute;
  top: 9px;
  right: 0;
`;

export const ErrorMessage = styled('span')`
  margin-top: 10px;
  font-size: 14px;
  color: red;
  display: block;
`;
